import React from 'react';

import './style.scss';

const OrangeCard = ({ className, children }) => {
  return (
    <div className={`OrangeCard ${className}`}>
      { children }
    </div>
  );
};

export default OrangeCard;
